import React from "react";
import styled from "styled-components";
import ButtonLink from "./ButtonLink";
import { AiTwotoneHome, AiTwotoneSetting } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { HiCode } from "react-icons/hi";
import { MdContacts } from "react-icons/md";

const Nav = styled.div`
  position: fixed;
  top: 0;
  left: -100%;
  display: flex;
  flex-direction: column;
  background-color: var(--background-color-main);
  align-items: center;
  justify-content: space-around;
  width: 100%;
  flex: 0.7;
  width: 50%;
  min-height: 100vh;
  max-height: 100vh;
  z-index: 20000;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  transition: all 0.5s ease-in-out;

  @media only screen and (max-width: 560px) {
    left: ${(props) => (props.toggle === "toggle" ? "0" : "-100%")};
  }
`;

function ResponsiveNav({ mobile, toggleNav }) {
  return (
    <Nav toggle={`${mobile ? "toggle" : ""}`}>
      <ButtonLink
        text={"Home"}
        icon={<AiTwotoneHome />}
        Id={"home"}
        onClick={toggleNav}
      />
      <ButtonLink
        text={"About"}
        icon={<BsFillPersonFill />}
        Id={"about"}
        onClick={toggleNav}
      />
      <ButtonLink
        text={"Skills"}
        icon={<AiTwotoneSetting />}
        Id={"skills"}
        onClick={toggleNav}
      />
      <ButtonLink
        text={"Projects"}
        icon={<HiCode />}
        Id={"projects"}
        onClick={toggleNav}
      />
      <ButtonLink
        text={"Contact"}
        icon={<MdContacts />}
        Id={"contact"}
        onClick={toggleNav}
      />
    </Nav>
  );
}

export default ResponsiveNav;
